"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allIds = allIds;
exports.byId = byId;
exports.topLevelOptions = topLevelOptions;
var _filter = _interopRequireDefault(require("lodash/filter"));
function allIds(state, action) {
  var sortedOptions = (0, _filter["default"])(action.options, {
    isActive: true
  }).sort(function (a, b) {
    return a.sequence - b.sequence;
  });
  return sortedOptions.map(function (option) {
    return option.id;
  });
}
function byId(state, action) {
  return action.options;
}
function topLevelOptions(state, action) {
  var sortedOptions = (0, _filter["default"])(action.options, {
    isActive: true,
    isDependent: false
  }).sort(function (a, b) {
    return a.sequence - b.sequence;
  });
  return sortedOptions.map(function (option) {
    return option.id;
  });
}
//# sourceMappingURL=loadOptionsSuccess.js.map